(() => {
  const SELECTED_CLASS = 'is-homepage-selected';
  const READY_CLASS = 'homepage-carousel-ready';

  function initCarousel(wrapper) {
    if (wrapper.dataset.homepageCarouselReady === 'true' || wrapper.classList.contains('flickity-enabled')) return;

    const slides = Array.from(wrapper.querySelectorAll(':scope > .slideshow__slide'));
    const section = wrapper.closest('.homepage-slideshow');
    const dots = Array.from(section?.querySelectorAll('[data-homepage-carousel-dot]') || []);
    const speed = Number.parseInt(wrapper.dataset.slideshowSpeed, 10) || 5000;
    const autoplay = wrapper.dataset.slideshowAutoplay === 'true';
    let selectedIndex = 0;
    let timer;
    let pointerStart;
    let ignoreNextClick = false;

    if (slides.length < 2) return;

    const select = (index) => {
      selectedIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === selectedIndex;
        slide.classList.toggle(SELECTED_CLASS, selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === selectedIndex;
        dot.classList.toggle('is-selected', selected);
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    };

    const restart = () => {
      window.clearInterval(timer);
      if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => select(selectedIndex + 1), speed);
      }
    };

    const pause = () => window.clearInterval(timer);

    wrapper.querySelectorAll('[slide-custom-prev]').forEach((button) => {
      button.addEventListener('click', () => {
        select(selectedIndex - 1);
        restart();
      });
    });
    wrapper.querySelectorAll('[slide-custom-next]').forEach((button) => {
      button.addEventListener('click', () => {
        select(selectedIndex + 1);
        restart();
      });
    });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        select(dotIndex);
        restart();
      });
    });
    wrapper.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.button > 0) return;
      const captureTarget = event.target instanceof Element ? event.target : wrapper;
      pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false, captureTarget };
      captureTarget.setPointerCapture(event.pointerId);
      wrapper.classList.add('is-homepage-dragging');
      pause();
    });

    wrapper.addEventListener('pointermove', (event) => {
      if (!pointerStart || event.pointerId !== pointerStart.id) return;
      const deltaX = event.clientX - pointerStart.x;
      const deltaY = event.clientY - pointerStart.y;

      if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
        pointerStart.moved = true;
        event.preventDefault();
      }
    });

    const finishPointer = (event, cancelled = false) => {
      if (!pointerStart || event.pointerId !== pointerStart.id) return;
      const drag = pointerStart;
      const deltaX = event.clientX - drag.x;
      const deltaY = event.clientY - drag.y;
      pointerStart = undefined;
      wrapper.classList.remove('is-homepage-dragging');
      if (drag.captureTarget.hasPointerCapture(event.pointerId)) drag.captureTarget.releasePointerCapture(event.pointerId);

      if (!cancelled && drag.moved && Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
        ignoreNextClick = true;
        window.setTimeout(() => {
          ignoreNextClick = false;
        }, 400);
        select(selectedIndex + (deltaX < 0 ? 1 : -1));
      }
      restart();
    };

    wrapper.addEventListener('pointerup', (event) => finishPointer(event));
    wrapper.addEventListener('pointercancel', (event) => finishPointer(event, true));
    wrapper.addEventListener('dragstart', (event) => event.preventDefault());
    wrapper.addEventListener('click', (event) => {
      if (!ignoreNextClick) return;
      event.preventDefault();
      event.stopPropagation();
      ignoreNextClick = false;
    }, true);
    wrapper.addEventListener('pointerenter', pause);
    wrapper.addEventListener('pointerleave', () => {
      if (!pointerStart) restart();
    });
    wrapper.addEventListener('focusin', pause);
    wrapper.addEventListener('focusout', (event) => {
      if (!wrapper.contains(event.relatedTarget)) restart();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else restart();
    });

    wrapper.dataset.homepageCarouselReady = 'true';
    wrapper.classList.add(READY_CLASS);
    select(0);
    restart();
  }

  function initAllCarousels() {
    document.querySelectorAll('[data-homepage-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  document.addEventListener('shopify:section:load', initAllCarousels);
})();
